import { render, staticRenderFns } from "./section3.vue?vue&type=template&id=41786436&scoped=true&"
import script from "./section3.vue?vue&type=script&lang=js&"
export * from "./section3.vue?vue&type=script&lang=js&"
import style0 from "./section3.vue?vue&type=style&index=0&id=41786436&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41786436",
  null
  
)

export default component.exports